export const APP_TYPE = import.meta.env.VITE_APP_TYPE || "website";
export const RETURN_WINDOW = 1000 * 60 * 60 * 24 * 23;
export const RETURN_WINDOW_SHIPPED = 1000 * 60 * 60 * 24 * 10;
